import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/** Guards route groups by authentication + user type. */
export function ProtectedRoute({ allow }: { allow: 'ADMIN' | 'CLIENT' }) {
  const { isAuthenticated, isAdmin } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  const okType = allow === 'ADMIN' ? isAdmin : !isAdmin;
  if (!okType) return <Navigate to="/" replace />;
  return <Outlet />;
}
